import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

export const RoleRedirect = () => {
  const { session, roles, initializing } = useAuth();

  if (initializing) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
        <p className="text-muted-foreground">Carregando...</p>
      </div>
    );
  }

  // Not logged in
  if (!session) {
    return <Navigate to="/login" replace />;
  }

  // Redirect based on role
  // Admin goes to /admin (placeholder for now)
  if (roles.includes('admin')) {
    return <Navigate to="/admin" replace />;
  }
  
  // Operador, Vendedor, and Influencer all use /app
  if (roles.includes('operador') || roles.includes('vendedor')) {
    return <Navigate to="/app" replace />;
  }

  // No recognized role - go to login
  return <Navigate to="/login" replace />;
};
